<template>
  <div class="locale-content">
    <div class="bloc validation">
      <checkbox class="shadow" v-model="checked"
                :disabled="!canAgree"
                :val="checked"
                :text="'<span class=&quot;bolder&quot;>By checking this box,</span> I confirm that I am of age and that I have read the terms and conditions of use and confidentiality of CAnnect.'"
      />
      <v-button :on-click="onclick" class="button" :disabled="!!!checked">
        <span>Continue to CAnnect</span>
      </v-button>
    </div>
  </div>
</template>

<script>
import VButton from '@/components/shared/VButton'
import Checkbox from '@/components/shared/Checkbox'

export default {
  name: 'GeneralConditionValidateEn',
  components: { VButton, Checkbox },
  props: {
    canAgree: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checked: false
    }
  },
  methods: {
    onclick () {
      if (this.canAgree && this.checked === true) {
        this.$emit('onAgree')
      }
    }
  }
}
</script>
